<div class="section" *ngIf="hasContent || editModeSet">
  <div class="section__header">
    <h2 class="section__header-text">College Information</h2>
  </div>
  <div class="section__body">
    <div class="data-block data-block--shaded-labels">
      <div *ngIf="affiliatesTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Affiliates:
          <mat-icon (click)="openEditEducationalInfoDialog(['College::Accreditation::'], null , 'Affiliates')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="affiliatesTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !affiliatesTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Approved for VA Training:

            <mat-radio-group *ngIf="editModeSet && !isRegionalManager" class="edu-vaTraining-radio-group radio-group">
                <div class="edu-va-training-radio-container">
                  <mat-radio-button class="va-training-radio-btn edu-radio-btn" value="1" [checked]="isCollegeApprovedForVaTraining" (change)="isCollegeApprovedForVaTrainingChange($event)">Yes</mat-radio-button>
                  &nbsp;
                  <mat-radio-button class="va-training-radio-btn edu-radio-btn" value="2" [checked]="!isCollegeApprovedForVaTraining" (change)="isCollegeApprovedForVaTrainingChange($event)">No</mat-radio-button>
                </div>
              </mat-radio-group>
        </div>
        <div class="data-block__value">
          {{ isCollegeApprovedForVaTraining | boolean : 'No'}}
        </div>
      </div>

      <div class="data-block__item">
        <div class="data-block__label">Distance Learning:
            <mat-radio-group *ngIf="editModeSet && !isRegionalManager" class="edu-distance-learning-radio-group radio-group">
                <div class="edu-distance-learning-radio-container">
                  <mat-radio-button class="distance-learning-radio-btn edu-radio-btn" value="1" [checked]="hasDistanceLearning" (change)="hasDistanceLearningChange($event)">Yes</mat-radio-button>
                  &nbsp;
                  <mat-radio-button class="distance-learning-radio-btn edu-radio-btn" value="2" [checked]="!hasDistanceLearning" (change)="hasDistanceLearningChange($event)">No</mat-radio-button>
                </div>
              </mat-radio-group>

        </div>
        <div class="data-block__value">
          {{ hasDistanceLearning | boolean : 'No'}}
        </div>
      </div>
      <div *ngIf="degreesTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Degrees:
          <mat-icon (click)="openEditEducationalInfoDialog(['College::Degrees::'], null , 'Degrees')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="degreesTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !degreesTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
      <div *ngIf="majorsTags.length || editModeSet" class="data-block__item">
        <div class="data-block__label">Majors:
          <mat-icon (click)="openEditEducationalInfoDialog(['College::Majors::'], null , 'Majors')" *ngIf="editModeSet && !isRegionalManager"
            class="edit-icon">edit</mat-icon>
        </div>
        <div class="data-block__value">
          <app-tag-bullet-list [items]="majorsTags"></app-tag-bullet-list>
          <div *ngIf="editModeSet && !majorsTags.length">
            <p>None Selected</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
